import LoadingMiddlewareTable from './Loadingmiddleware';
import Pagination from '../../plugins/Pagination/paginationBar';
import { v4 as uuidv4 } from 'uuid';
import FilteredDataProvider from '../../plugins/Filters';
import OrderContext from '../../memory/OrderContext';

class EmptyMiddlewareTable extends LoadingMiddlewareTable {
  stylingErrorDarkNess: string;

  constructor(props: any) {
    super(props);
    this.stylingTBodyComp = 'px-2 mx-4 rounded-lg shadow-md h-full';
    this.stylingErrorDarkNess = 'text-gray-700 text-opacity-50 text-base';
  }

  public override tBodyComp() {
    return (
      <OrderContext.Consumer>
        {(context) => (
          <div key={uuidv4()} className="flex items-center justify-center p-4 text-lg font-semibold mxs:h-[calc(100vh-325px)] h-[calc(124vh-325px)] w-full">
            <div className="flex items-center justify-center">
              <div className="relative flex flex-col items-center justify-center">
                <div className="md:w-80 w-60">
                  {/* <img src={EmptyTransaction} className="flex items-center justify-center bg-cover rounded-xl opacity-75" alt="" /> */}
                </div>
                <div className="pt-0">
                  <p className="normal-case text-center text-sm font-medium">
                    No orders found!
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </OrderContext.Consumer>
    );
  }

  public override tableComp() {
    return (
      <div className="w-full px-8">
        {/* <div className="flex justify-between items-start my-4 shadow-tableShadow gap-2 pr-10 max-lg:pr-0 p-2.5"> */}
        <FilteredDataProvider />
        {/* </div> */}

        <div className="lg:px-6 px-5 pb-4 rounded overflow-x-hidden overflow-y-auto shadow-tableShadow bg-primary2">
          <table {...this.getTableProps()} className={`${this.stylingTableComp} border-collapse border-spacing-3`}>
            {this.theadComp()}
            {/* <Divider className='w-full'/> */}
          </table>
          {this.tBodyComp()}
        </div>

        <div className="ml-6">
          <Pagination initialLoad={true} jwtToken={this.props.jwtToken} />
        </div>
      </div>
    );
  }
}

export default EmptyMiddlewareTable;
